import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useJoinFloor } from "modules/joinFloor";
import { selectTheaterSpaces } from "modules/theater/selectors";
import { selectIsCurrentFloorInTheaterSpaces } from "modules/space/redux/selectors";
import { usePrevious } from "helpers/reactHooksUtils";
import { selectCurrentEventId } from "modules/event/selectors";
import logger from "logging/logger";

export const AutoFloorSwitcher = () => {
  const eventId = useSelector(selectCurrentEventId);
  const theaterFloors = useSelector(selectTheaterSpaces);
  const { switchFloor } = useJoinFloor();
  const prevEventId = usePrevious(eventId);
  const isCurrentFloorInTheaterSpaces = useSelector(
    selectIsCurrentFloorInTheaterSpaces,
  );
  const prevIsCurrentFloorInTheaterSpaces = usePrevious(
    isCurrentFloorInTheaterSpaces,
  );

  useEffect(() => {
    if (
      eventId === prevEventId &&
      !isCurrentFloorInTheaterSpaces &&
      prevIsCurrentFloorInTheaterSpaces
    ) {
      logger.info(
        "[AutoFloorSwitcher] moving user to the first floor, as current floor is deleted.",
      );
      switchFloor({ targetFloorId: theaterFloors[0] });
    }
  }, [
    eventId,
    isCurrentFloorInTheaterSpaces,
    prevEventId,
    prevIsCurrentFloorInTheaterSpaces,
    switchFloor,
    theaterFloors,
  ]);

  return null;
};
